<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BnAmbG/tc-custom/9781588169167.jpg?1729082652120" alt="This image is the cover for the book Country Living Simple Country Wisdom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Country Living Simple Country Wisdom
      </h1>
      <p class="bookDescription body article font2">
        <b>From a leading American lifestyle magazine, advice and tips to easily create a clean, organized, relaxing, and inviting home—includes photos.</b><br/>  <br/> Has life become a bundle of stress and mess? Top-selling author Susan Waggoner has the solution. This ingenious, fun-to-read illustrated guide offers tried-and-true household hints and practical solutions to everyday problems, from the “A-to-Z Guide to Food” to “The Tao of Laundry.” Whether it's a no-scrub trick to make bathroom faucets gleam or surefire advice on keeping your house harmonious with as little fuss as possible, <i>Country Living Simple Country Wisdom</i> is the key to creating a home that's cheerful, welcoming, and warm.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Waggoner
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sterling Publishing Co., Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2bc617ca